import { Controller } from '@hotwired/stimulus';

// #AI: jQuery and NProgress are loaded via Sprockets as global variables
const $ = window.jQuery || window.$;
const NProgress = window.NProgress;

export default class extends Controller {
  static targets = ['switch'];

  connect() {
    if (!$) {
      console.error('[WeightSwitchController] jQuery not available');
      return;
    }
    this.syncSwitch();
  }

  load(value) {
    // This should be replaced with fetch API once we're not using jquery
    // anymore
    $.get(this.data.get('url'), { weight: value })
      .done((response) => {
        this.element.innerHTML = response;
        this.checked = value;
        this.syncSwitch();
        NProgress.done();
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        console.error('Request failed:', textStatus, errorThrown);
        alert(
          'An error occurred while processing your request. Please try again.'
        );
        NProgress.done();
      });
  }

  toggle(event) {
    NProgress.start();
    this.load(event.target.checked);
  }

  get checked() {
    return this.data.get('checked') === 'true';
  }

  set checked(value) {
    this.data.set('checked', value ? 'true' : 'false');
    this.syncSwitch();
  }

  syncSwitch() {
    this.switchTarget.checked = this.checked;
  }
}
